import { render } from "./FirstTimerPerformanceReport.vue?vue&type=template&id=fd2e5bce&scoped=true"
import script from "./FirstTimerPerformanceReport.vue?vue&type=script&lang=js"
export * from "./FirstTimerPerformanceReport.vue?vue&type=script&lang=js"

import "./FirstTimerPerformanceReport.vue?vue&type=style&index=0&id=fd2e5bce&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd2e5bce"]])

export default __exports__